import { EntityTypes } from 'constants/entities';
import { LoadingState } from 'types/domain/base';
import { SceneProjection } from 'types/domain/scene';

export interface IAsset {
  id: string;
  type: AssetType;
  entityType: EntityTypes;
  entityId: number;
  sceneId?: number;
  mediaId: number;
  url: string;
  fallback?: string;
  loader?: any;
  loading?: LoadingState;
  error?: string;
  progress?: number;
  dimensions?: { width: number; height: number };
  manifest?: any;
  orientation?: Orientation;
  rotation?: number;
  start?: number;
  attempts?: number;
  projection: SceneProjection;
}

export function assetId(entityType: EntityTypes, id: number, type: AssetType, mediaId: number) {
  return `${entityType}${id}${type}${mediaId}`;
}

export enum Orientation {
  LANDSCAPE = 0,
  PORTRAIT = 1,
}

export enum AssetType {
  THUMB = '_thumb',
  PREVIEW = '_preview',
  IMAGE = '_image',
  VIDEO = '_video',
  MODEL = '_model',
  AUDIO = '_audio',
}
